import { ErrorBoundary } from "react-error-boundary";
import { useSelector } from "react-redux";
import { ErrorFallback } from "../../../error-boundary/errorFallback";
import { defaultReset } from "../../../error-boundary/logerror";
import { RootState } from "../../../state/store";
import Calendar from "../../Calendar";
import TeamCalendar from "../../Calendar/Team";
import Reports from "../../Reports";
import MISReports from "../../Reports/mis";
import UserPreference from "../../UserPreference";
import UserProfile from "../../UserProfile";
import Sidebar from "../sidebar/sidebar";
import Tabs from "../tabRow/tabNavigations";
import Topbar from "../topBar/topBar";
import "./index.scss";
import WorkflowLayout from "./workflowLayout";
function FullWidth() {
    const SiteInfo = useSelector((state: RootState) => state.SiteInformation);

    function Showmenu() {
        const box = document.querySelector(".NavItemsE") as HTMLElement | null;
        box?.classList.toggle("expanded");
        alert(111);
    }

    function closeAttach() {
        var allElements = document.querySelectorAll('*[id^="mAttach-"]');
        allElements.forEach(item => {
            item.className = "MainAttachmentOptionsContainer invisible";
        });
    }

    return (
        <>
            <div className="layout">
                <div className="aside">
                    <ErrorBoundary
                        FallbackComponent={ErrorFallback}
                        onReset={defaultReset}
                    >
                        <Sidebar FullWidth={true} />
                    </ErrorBoundary>
                </div>
                <div className="main-layout">
                    <div className="top-bar">
                        <ErrorBoundary
                            FallbackComponent={ErrorFallback}
                            onReset={defaultReset}
                        >
                            <Topbar FullWidth={true} />
                        </ErrorBoundary>
                    </div>
                    {SiteInfo.userPreferanceVisible === true ? (
                        <UserPreference></UserPreference>
                    ) : SiteInfo.userProfileVisible === true ? (
                        <UserProfile></UserProfile>
                    ) : SiteInfo.reportsVisible === true ? (
                        <Reports></Reports>
                    ) : SiteInfo.MISreportsVisible === true ? (
                        <MISReports></MISReports>
                    ) : SiteInfo.calendarVisible === true ? (
                        <Calendar></Calendar>
                    ) : (
                        <>
                            <div className="paddingForRows">
                                <ErrorBoundary
                                    FallbackComponent={ErrorFallback}
                                    onReset={defaultReset}
                                >
                                    <Tabs FullWidth={true}></Tabs>
                                </ErrorBoundary>
                            </div>
                            <div className="main-content">
                                {/* ----------main content---------- */}

                                <div
                                    style={{ padding: "0px", height: "100%", display: "flex", flexDirection: "column" }}
                                >
                                    {
                                        <ErrorBoundary
                                            FallbackComponent={ErrorFallback}
                                            onReset={defaultReset}
                                        >
                                            {SiteInfo.teamCalendarVisible === true ? (
                                                <TeamCalendar></TeamCalendar>
                                            ) : (
                                                <WorkflowLayout
                                                    FullWidth={true}
                                                    Popped={false}
                                                    interface="tab"
                                                ></WorkflowLayout>
                                            )}
                                        </ErrorBoundary>
                                    }
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default FullWidth;
